import { render } from "./Income.vue?vue&type=template&id=be2ad6bc&scoped=true"
import script from "./Income.vue?vue&type=script&lang=js"
export * from "./Income.vue?vue&type=script&lang=js"

import "./Income.vue?vue&type=style&index=0&id=be2ad6bc&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2ad6bc"]])

export default __exports__